export type SubscriptionPlanId = "free" | "base" | "core";

export type SubscriptionOverviewSnapshot = {
  plan: {
    id: SubscriptionPlanId | string;
  };
  usage: {
    activeSites: number;
  };
};

export type DowngradeToFreeState = {
  canDowngrade: boolean;
  blockedReason: string | null;
};

const DEFAULT_FREE_MAX_ACTIVE_SITES = 1;

export function getDowngradeToFreeState(
  overview: SubscriptionOverviewSnapshot,
  freeMaxActiveSites = DEFAULT_FREE_MAX_ACTIVE_SITES
): DowngradeToFreeState {
  if (overview.plan.id === "free") {
    return {
      canDowngrade: false,
      blockedReason: null,
    };
  }

  if (overview.usage.activeSites <= freeMaxActiveSites) {
    return {
      canDowngrade: true,
      blockedReason: null,
    };
  }

  const sitesToDeactivate = overview.usage.activeSites - freeMaxActiveSites;
  return {
    canDowngrade: false,
    blockedReason: `Deactivate ${sitesToDeactivate} site${
      sitesToDeactivate === 1 ? "" : "s"
    } before downgrading to Free.`,
  };
}
